<template>
	<page>
		<title-view>
			מסך היסטורית משחקים
		</title-view>
		<row>
			<c-col>
				<game-logs-table />
			</c-col>
		</row>
	</page>
</template>

<script>
import GameLogsTable from "src/view/gamelogs/GameLogsTable";

export default {
	name: "GameLogsView",
	components: { GameLogsTable },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
	},

};
</script>

<style scoped>

</style>
